import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { rateSetModel } from "../rateSetModel";

export function RateSet() {
    const {
        loadData,
        resetState,
        loadDs,
        loadAppPage
    } = rateSetModel()
    useEffect(() => {
        loadDs()
        loadData({ pageNum: 1 }, {}).then()
        loadAppPage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

